// extracted by mini-css-extract-plugin
module.exports = {"color1":"#e1953c","color2":"#cd324e"};